import { Badge, HStack } from '@chakra-ui/react'
import type { Demand } from '../types'
import { getDemandStatusLabel, getDemandStatusPalette } from '../demandStatus'

interface MarketplaceStatusBadgeProps {
  demand: Pick<Demand, 'status' | 'isArchived'>
}

/**
 * Status of a marketplace demand as shown to a SIB. Mirrors the two facts the Union
 * side shows: how far the demand is brokered, and whether it is finished (archived).
 *
 * Deliberately separate from the Union wording, which exposes internal workflow
 * states such as "Handlung erforderlich".
 */
export function MarketplaceStatusBadge({ demand }: MarketplaceStatusBadgeProps) {
  const label = getDemandStatusLabel(demand.status)

  if (!label && !demand.isArchived) return null

  return (
    <HStack gap={2}>
      {label && (
        <Badge colorPalette={getDemandStatusPalette(demand.status)} variant="solid">
          {label}
        </Badge>
      )}

      {demand.isArchived && (
        <Badge colorPalette="gray" variant="solid">
          Beendet
        </Badge>
      )}
    </HStack>
  )
}
